$(document).ready(function() {
	if(!document.querySelector('.C0088')) return false;	
	var componentCarouselSimple = {
		$el : null,
		init : function() {
			this.$el = $('.C0088');
			this.$el.not('.bindSlick').find('.spec-list').not('.none-slide').not('.slick-initialized').each(function(){
				if( $(this).find('.item').length>1 ) {
                    componentCarouselSimple.runSlick($(this));
				}
			}).parents('.C0088').addClass('bindSlick');
		},
		runSlick: function($obj) {
            var slickSetting = {
                appendDots:$obj.siblings('.slick-indicator').find('.slick-dot-wrap'),
				responsive: [
					{
						breakpoint: 9999,
						settings: 'unslick'
					},
					{
						breakpoint: 767,
						 settings: {
							infinite: false,
							slidesToShow: 1,
							slidesToScroll: 1,
							arrows : false,
							dots: true,
						}
					}
                ]
            }
			$obj.slick(slickSetting);
			$obj.on('afterChange', function(event, slick, currentSlide){
                //console.log('..');
			});
			$obj.on('breakpoint', function(event, slick, breakpoint) {
				// console.log('breakpoint ' +  breakpoint);
				if( breakpoint === 767 ) {
					eventStopOn();
				}
				if ( breakpoint === 9999 ) {
					$obj.off('mousedown.stop touchstart.stop');
				}
			});
			$(window).on('resize',function(){
				$obj.slick('resize');
				if( ! mql.maxSm.matches) {
					$obj.find('.item').removeAttr('role id tabindex aria-describedby aria-hidden');
				}
			}).resize();
			function eventStopOn() {
				$obj.on('mousedown.stop touchstart.stop', function (e) {
					e.stopPropagation();
				});
			}
			if( mql.maxSm.matches) {
				eventStopOn();
			}
		}
	};
	componentCarouselSimple.init();
	
});